import React from "react";
import PropTypes from "prop-types";
import { sizes, srcset } from "../../../helpers/image";

const Slide = ({ imgDefault, imgRetina, width, alt }) => {
  return (
    <img
      className={`is-loaded`}
      src={imgRetina || imgDefault}
      srcSet={srcset(width, imgRetina, imgDefault)}
      sizes={sizes(width, 1)}
      alt={alt}
      width={width}
      height={width * (4 / 5)}
      style={{ maxWidth: 815, width: "100%", height: "auto" }}
    />
  );
};

Slide.displayName = "ExhibitionsOnView.Slide";

Slide.propTypes = {
  imgDefault: PropTypes.string.isRequired,
  imgRetina: PropTypes.string,
  width: PropTypes.number.isRequired,
  alt: PropTypes.string,
};

export default Slide;
